import routes from './routes'
import { Fetch } from '../fetch'

class LoginService {
  login (payload) {
    return Fetch('post', routes.LOGIN, payload, { customTimeout: 10000 })
  }
}

export default new LoginService()
